import {
    IContaProduto,
    IContaProdutoInadimplente,
} from "../../../Interfaces/Cobranca/ContaProduto/ContaProdutoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarProdutosPorContaService(
    idConta: number,
    idTipoCaso: number
) {
    return Service(
        Axios.get<Array<IContaProduto>>(
            `/cobranca/contaproduto/listarprodutosporconta?idConta=${idConta}&idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function ListarProdutosPorContaAdimplentesService(
    idConta: number,
    idTipoCaso: number
) {
    return Service(
        Axios.get<Array<IContaProdutoInadimplente>>(
            `/cobranca/contaproduto/listarprodutosporcontaverificaadimplentes?idConta=${idConta}&idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function ListarProdutosPorContaAdimplenciaService(
    idConta: number
) {
    return Service(
        Axios.get<Array<IContaProdutoInadimplente>>(
            `/cobranca/contaproduto/listarprodutosporcontaadimplencia?idConta=${idConta}`
        )
    );
}

export async function VerificaProdutoAdimplenteService(idChaveERP: string) {
    return Service(
        Axios.get<boolean>(
            `/cobranca/contaproduto/verificaprodutoadimplente?idChaveERP=${idChaveERP}`
        )
    );
}

export async function VerificaInadimplenciaProdutoService(
    ID_CHAVE_ERP: string
) {
    return Service(
        Axios.get<boolean>(
            `/cobranca/contaproduto/verificainadimplenciaproduto?ID_CHAVE_ERP=${ID_CHAVE_ERP}`
        )
    );
}

export async function VerificarPossibilidadeCobrancaPorProdutoService(
    idProdutos: Array<number>
) {
    return Service(
        Axios.post<Array<boolean>>(
            `/cobranca/contaproduto/verificapossibilidadecobrancaporproduto`,
            idProdutos
        )
    );
}

export async function VerificaPossibilidadeCobrancaPorAtendimentoService(
    idCaso: number
) {
    return Service(
        Axios.get<boolean>(
            `/cobranca/contaproduto/verificapossibilidadecobrancaporatendimento?idCaso=${idCaso}`
        )
    );
}
